<template>
  <div>
    <Modal v-model="logModal" width="1000" footer-hide @on-cancel="logModalClose">
      <Spin size="large" fix v-if="loading"></Spin>
      <div style="margin-top: 20px">
        <Alert v-if="error" type="warning" show-icon>获取日志数据失败</Alert>
        <div v-else>
          <radio-group v-model="searchForm.since" type="button" size="small" @on-change="getLogs(containerId, searchForm.node)">
            <radio :label=43200>12小时</radio>
            <radio :label=86400>1天</radio>
            <radio :label=259200>3天</radio>
            <radio :label=604800>7天</radio>
            <radio :label=2592000>1月</radio>
            <radio :label=7776000>3月</radio>
            <radio :label=15552000>半年</radio>
            <radio :label=null>all</radio>
          </radio-group>
          <span style="margin-left: 40px">
            <span>显示时间 </span>
            <i-switch v-model="searchForm.timestamps" @on-change="getLogs(containerId, searchForm.node)">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </span>
          <span style="margin-left: 40px">
            <span>自动刷新 </span>
            <i-switch v-model="autoRefresh" @on-change="autoRefreshChange">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </span>
          <Divider/>
          <pre class="container-logs-pre" id="container-logs-pre-id">{{ logs }}</pre>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getContainerLogs } from '@/api/container/container'

export default {
  name: 'containerLogs',

  data () {
    return {
      error: false,
      logModal: false,
      loading: false,
      logs: null,
      containerId: null,
      searchForm: {
        since: 43200,
        timestamps: false
      },
      autoRefresh: false,
      autoRefreshTimer: null
    }
  },
  beforeDestroy () {
    clearInterval(this.autoRefreshTimer)
    this.autoRefreshTimer = null
  },
  methods: {
    getLogs (containerId, nodeId, loading = true) {
      this.containerId = containerId
      this.searchForm.node = nodeId
      this.logModal = true
      if (loading) {
        if (this.autoRefresh) {
          clearInterval(this.autoRefreshTimer)
          this.autoRefreshTimer = null
          this.setTimer()
        }
        this.loading = true
        this.logs = null
      }
      getContainerLogs(containerId, this.searchForm).then(res => {
        this.loading = false
        this.logs = res.data
        this.error = false
        this.$nextTick(function () {
          let div = document.getElementById('container-logs-pre-id')
          div.scrollTop = div.scrollHeight
        })
      }).catch(res => {
        this.loading = false
        this.error = true
        console.log(res.response)
      })
    },
    logModalClose () {
      clearInterval(this.autoRefreshTimer)
      this.autoRefreshTimer = null
    },
    autoRefreshChange (autoRefresh) {
      if (autoRefresh) {
        this.setTimer()
      } else {
        clearInterval(this.autoRefreshTimer)
        this.autoRefreshTimer = null
      }
    },
    // 自动刷新
    setTimer () {
      if (this.autoRefreshTimer == null) {
        this.autoRefreshTimer = setInterval(() => {
          this.getLogs(this.containerId, this.searchForm.node, false)
        }, 5000)
      }
    }
  }
}
</script>

<style scoped>
  .container-logs-pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    padding: 0;
    overflow-y: auto;
    max-height: 600px;
    padding-bottom: 5px;
  }
  .container-logs-pre::-webkit-scrollbar {
    width: 5px;
  }
  .container-logs-pre::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .container-logs-pre::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
